export default __webpack_public_path__ + "static/media/Resume.2c99be38.pdf";